import { render, staticRenderFns } from "./payments-editor-act.vue?vue&type=template&id=641609c5"
import script from "./payments-editor-act.vue?vue&type=script&lang=js"
export * from "./payments-editor-act.vue?vue&type=script&lang=js"
import style0 from "./payments-editor-act.vue?vue&type=style&index=0&id=641609c5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports